module.exports = __webpack_public_path__ + "img/fq_step2.d1282ac0.png";